import { createFileRoute } from '@tanstack/react-router'

import { GroupsPage } from '@/pages/team/Groups.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/groups/',
)({
  component: GroupsPage,
})
